<div *ngIf="configs !== null">
  <mat-list>
    <mat-list-item *ngFor="let config of configs">
      <div matLine style="padding: 6px 16px">
        <div *ngIf="config.type.dataType === 'Bool'">
          <mat-slide-toggle [id]="config.configTypeId" [checked]="config.value.toLowerCase() === 'true'" (change)="onChangeSlide($event)">{{config.type.displayName}}</mat-slide-toggle>
        </div>
        <div *ngIf="config.type.dataType === 'Text'">
          <div matLine>
            <mat-form-field>
              <mat-label>{{config.type.displayName}}</mat-label>
              <input matInput type="text" [id]="config.configTypeId" [value]="config.value" (keyup.enter)="onChangeText($event)" (blur)="onChangeText($event)">
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
